var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIconBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/icon/logout/logout_black (20px) ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/logout/logout_black-(20px)-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/logout/green"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0.5 L3.5,0.5 C1.84314575,0.5 0.5,1.84314575 0.5,3.5 L0.5,16.5 C0.5,18.1568542 1.84314575,19.5 3.5,19.5 L10,19.5",
    id: "Path-2",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 7,
    y: 9.5,
    width: 12,
    height: 1
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    stroke: "#000000",
    points: "14.3 5 19.3 10 14.3 15"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIconBlack);
export default __webpack_public_path__ + "static/media/logout_icon_black.8ed713eac104ef7f10b90b84aeda0fe7.svg";
export { ForwardRef as ReactComponent };